import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";

const ViewBdData = () => {
  const [bddata, setBddata] = useState([]);
  const baseUrl = process.env.REACT_APP_BASEURL1;
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("id");
  const [agencyadimindata, setAgencyAdminData] = useState([]);
  
  // Pagination states
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
///////////

//////////
  const edit = async (id) => {
    try {
      const { data } = await axios.get(`${baseUrl}/bdpanel/getone?id=${id}`);
      setBddata(data.data);
      toast.success(data.message);
    } catch (error) {
      console.error("Error edit BD:", error);
      toast.error("Failed to edit BD");
    }
  };

  useEffect(() => {
    if (userId) {
      edit(userId);
    
    }
  }, [userId]);
//  setTimeout(() => {
  const manageagencadminApi = async (currentPage = page, limit = entriesPerPage) => {
    try {
      setLoading(true);
      const agencyAdminResponse = await axios.post(
        `${baseUrl}/agencadminpanel/getagencyadmin?page=${currentPage}&limit=${limit}`,
        { 
          createBy: bddata?.uniqueId
        }
      );
      
      if (agencyAdminResponse.data.data) {
        setAgencyAdminData(agencyAdminResponse.data.data);
        setCount(agencyAdminResponse.data.total || agencyAdminResponse.data.count || agencyAdminResponse.data.data.length);
      } else {
        toast.error("Failed to retrieve Agency Admin list");
      }
    } catch (error) {
      console.error("Error fetching Agency Admin list:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (bddata?.uniqueId) {
      manageagencadminApi();
    }
  }, [bddata, page, entriesPerPage]);

  const renderSerialNumber = (index) => {
    return (page - 1) * entriesPerPage + index + 1;
  };
  // }, 2000);
  
  
  
  return (
    <>
      <section className="content-header">
        <h1>View BD</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li>
            <Link to="/admin/viewBd">Manage Bd</Link>
          </li>
          <li className="active">View Bd</li>
        </ol>
      </section>
      <section className="content">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="col-md-10 col-12">
            <form
              role="form"
              method="post"
              id="specialitiesForm"
              encType="multipart/form-data"
            >
              <div className="box box-warning">
                <div
                  className="box-header with-border"
                  style={{ display: "flex" }}
                >
                  <div style={{ position: "relative" }}>
                    <img
                      src={`${baseUrl}${bddata.image}`}
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                      }}
                      id="pro_img"
                    />
                    <button
                      type="button"
                      id="edit_btn"
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-5px",
                        background: "transparent",
                        border: "none",
                      }}
                    >
                      <i className="fa-solid fa-pen-to-square" />
                    </button>
                  </div>
                  <div>
                    <div style={{ marginLeft: "15px", fontSize: "20px" }}>
                      <span
                        className=" label label-warning"
                        style={{ fontSize: "10px" }}
                        aria-label="user type"
                      >
                        Bd
                      </span>
                    </div>
                    <div style={{ marginLeft: "15px", fontSize: "20px" }}>
                      {bddata?.name}
                    </div>
                  </div>
                </div>
                <div className="box-body">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Bd Name*</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={bddata?.name}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Bd Code*</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={bddata?.uniqueId}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Number*</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={bddata?.number}
                        readOnly
                      />
                    </div>
                  </div>
                  {/* <div className="col-sm-6">
                    <div className="form-group">
                      <label>Join Date*</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={bddata?.joinDate}
                        readOnly
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-sm-6">
                    <div className="form-group">
                      <label>Hosts*</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={bddata?.hosts}
                        readOnly
                      />
                    </div>
                  </div> */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Password*</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={bddata?.password}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            
            {/* Entries per page and pagination controls */}
            <div className="row" style={{ padding: "16px 0px", marginBottom: "20px" }}>
              <div className="entries-per-page col-md-6">
                <label htmlFor="entries">Entries per page:</label>
                <select
                  id="entries"
                  value={entriesPerPage}
                  onChange={(e) => {
                    setEntriesPerPage(parseInt(e.target.value));
                    setPage(1); // Reset to first page when changing entries per page
                  }}
                  style={{ marginLeft: "10px", padding: "5px" }}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div className="col-md-6" style={{ textAlign: "right" }}>
                <span>Total Entries: {count}</span>
              </div>
            </div>
            
            <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Image</th>
                      <th>Aegncy Admin Code</th>
                      <th>Aegncy Admin Name</th>
                      <th>BD Id</th>
                      <th>Phone</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <i className="fa fa-spinner fa-spin" style={{ marginRight: "10px", fontSize: "18px" }}></i>
                            Loading...
                          </div>
                        </td>
                      </tr>
                    ) : agencyadimindata.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                          No Agency Admin data found
                        </td>
                      </tr>
                    ) : (
                      agencyadimindata.map((item, index) => (
                        <tr key={index}>
                          <td>{renderSerialNumber(index)}</td>
                          <td>
                            <img src={`${item.image}`} alt="" width={"80px"} />
                          </td>
                          <td>{item.uniqueId}</td>
                          <td>{item.name}</td>
                          <td>{item.createBy}</td>
                          <td>{item.number}</td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-default dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                Action
                                <span className="caret"></span>
                              </button>
                              <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                  <Link
                                    to={`/admin/viewagencyadmin/?id=${item._id}`}
                                    role="menuitem"
                                    tabIndex={-1}
                                  >
                                    View
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`/admin/editagencyadmin?id=${item._id}`}
                                    role="menuitem"
                                    tabIndex={-1}
                                  >
                                    Edit
                                  </Link>
                                </li>
                                {/* <li>
                                  <Link
                                    // onClick={() => deleteagencyadimin(item._id)}
                                    // role="menuitem"
                                    // tabIndex={-1}
                                  >
                                    Delete
                                  </Link>
                                </li> */}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                
                {/* Pagination controls */}
                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-md-12">
                    <ul className="pagination" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <li style={{ marginRight: "10px" }}>
                        <span>Total Entries: {count}</span>
                      </li>
                      <li>
                        <span
                          style={{ 
                            cursor: page > 1 ? "pointer" : "not-allowed", 
                            padding: "8px 12px",
                            border: "1px solid #ddd",
                            marginRight: "5px",
                            backgroundColor: page > 1 ? "#fff" : "#f5f5f5",
                            color: page > 1 ? "#337ab7" : "#999"
                          }}
                          onClick={() => {
                            if (page > 1) {
                              setPage(page - 1);
                            }
                          }}
                        >
                          Previous
                        </span>
                      </li>
                      <li style={{ margin: "0 10px" }}>
                        <span>Page {page} of {Math.ceil(count / entriesPerPage) || 1}</span>
                      </li>
                      <li>
                        <span
                          style={{ 
                            cursor: page < Math.ceil(count / entriesPerPage) ? "pointer" : "not-allowed",
                            padding: "8px 12px",
                            border: "1px solid #ddd",
                            marginLeft: "5px",
                            backgroundColor: page < Math.ceil(count / entriesPerPage) ? "#fff" : "#f5f5f5",
                            color: page < Math.ceil(count / entriesPerPage) ? "#337ab7" : "#999"
                          }}
                          onClick={() => {
                            if (page < Math.ceil(count / entriesPerPage)) {
                              setPage(page + 1);
                            }
                          }}
                        >
                          Next
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewBdData;
